import { baseColors } from "@Constants/baseStyles"
import { Ionicons } from "@expo/vector-icons"
import React, { useEffect, useState } from "react"
import { View } from "react-native"
import DropDownPicker from "react-native-dropdown-picker"

export const CustomDropDownPicker = (props) => {
    const { defaultValue, data, handleChange, placeholder, style, renderListItem, setIsDropDownOpen } = props
    const [value, setValue] = useState(undefined)
    const [open, setOpen] = useState(false)
    const [items, setItems] = useState(data)

    useEffect(() => {
        if (value) {
            handleChange?.(value)
        }
    }, [value])

    useEffect(() => {
        setValue(defaultValue)
    }, [defaultValue])

    return (
        <View style={{ ...style }}>
            <DropDownPicker
                itemSeparator
                onOpen={() => setIsDropDownOpen?.(true)}
                onClose={() => setIsDropDownOpen?.(false)}
                itemKey={"value"}
                schema={{ label: "label", value: "value", testID: "id" }}
                placeholder={placeholder}
                style={{ height: 47, borderWidth: 0, backgroundColor: baseColors.green.light }}
                dropDownContainerStyle={{ zIndex: 10, borderColor: baseColors.green.primary }}
                itemSeparatorStyle={{ backgroundColor: baseColors.green.primary }}
                ArrowDownIconComponent={() => (
                    <Ionicons color={baseColors.green.primary} size={20} name={"chevron-down"} />
                )}
                textStyle={{ color: baseColors.black, fontSize: 16 }}
                ArrowUpIconComponent={() => <Ionicons color={baseColors.green.primary} size={20} name={"chevron-up"} />}
                placeholderStyle={{ fontFamily: "OpenSans", fontSize: 16, color: baseColors.green.primary }}
                open={open}
                renderListItem={renderListItem && renderListItem}
                value={value}
                items={items}
                setOpen={setOpen}
                setValue={setValue}
                setItems={setItems}
            />
        </View>
    )
}
